import { Outlet } from "react-router-dom";

export default function Cache() {
  return <Outlet context={{}} />;
}
